
let salary_fields = {
    title: {
        create: 'เพิ่มข้อมูลเงินเดือน',
        edit: 'แก้ไขข้อมูลเงินเดือน'
    },
    inputs: {
        divider_1: {
            input_type: 'divider',
            label: 'ข้อมูลพนักงาน',
            col_span: 23
        },
        month_period: {
            input_type: 'text',
            placeholder: 'งวดเงินเดือนที่',
            col_span: 11,
            required: true,
        },
        purchase_datetime: {
            input_type: 'daterange',
            placeholder: 'วันที่ทำจ่าย',
            col_span: 11,
            required: true,
        },
        employee_type_id: {
            input_type: 'select',
            modelname: 'EmployeeType',
            label_key: 'name',
            placeholder: 'ประเภทพนักงาน',
            required: true,
            col_span: 5,
        },
        car_company_id: {
            input_type: 'select',
            modelname: 'CarCompany',
            label_key: 'name',
            placeholder: 'บริษัทรถ',
            col_span: 5,
            driver_type: true,
        },
        driver_id: {
            input_type: 'select',
            modelname: 'Driver',
            label_key: 'name',
            placeholder: 'ชื่อ-นามสกุลผู้ขับ',
            col_span: 5,
            required: true,
            driver_type: true,
        },
        driver_no: {
            input_type: 'text',
            placeholder: 'รหัสพนักงาน',
            col_span: 5,
            non_editable: true,
            driver_type: true,
        },
        divider_2: {
            input_type: 'divider',
            label: 'ข้อมูลรายได้',
            col_span: 23
        },
        driver_salary: {
            input_type: 'number',
            placeholder: 'เงินเดือนค่าจ้าง',
            col_span: 11,
            non_editable: true,
        },
        set_leader: {
            input_type: 'text',
            placeholder: 'หัวหน้าชุด',
            col_span: 11,
            non_editable: true,
        },
        car_care_text: {
            input_type: 'text',
            placeholder: 'รายได้อื่นๆ',
            col_span: 11,
        },
        p_smart: {
            input_type: 'text',
            placeholder: 'ค่าตำแหน่ง',
            col_span: 11,
        },
        cost_table:{
            col_span: 18,
            input_type: 'table',
            target_key: 'branches',
            target_modelname: 'CostDriver',
            table_columns: [
                {
                    title: 'รายการ',
                    dataIndex: 'order',
                    key: 'order',
                },
                {
                    title: 'จำนวนรายการ',
                    dataIndex: 'number',
                    key: 'number',
                },
                {
                    title: 'จำนวนเงิน',
                    dataIndex: 'amount',
                    key: 'amount',
                },
            ],
            drawer_fields: {
                title: '',
                show: false,
                type: 'drawer',
                instance: {},
                inputs: {
                    order: {
                        input_type: 'text',
                        placeholder: 'รายการ',
                        required: true,
                    },
                    number: {
                        input_type: 'text',
                        placeholder: 'จำนวนรายการ',
                        required: false,
                    },
                    amount: {
                        input_type: 'text',
                        placeholder: 'จำนวนเงิน',
                        required: false,
                    }
                }
            }
        },
        sum_cost:{
            input_type: 'text',
            placeholder: 'เงินได้รวม',
            col_span:23,
            non_editable: true,
        },
        }
    ,
    inputs2: {
        divider_3: {
            input_type: 'divider',
            label: 'ข้อมูลรายการหัก',
            col_span: 23
        },
        insurance_price: { input_type: 'text', placeholder: 'ประกันสังคม', col_span: 11 },
        insurance_work_price: { input_type: 'text', placeholder: 'เงินประกันทำงาน', col_span: 11 },
        insurance_early_price: { input_type: 'text', placeholder: 'เงินเดือนจ่ายก่อนหน้า', col_span: 11 },
        leave_price: { input_type: 'text', placeholder: 'ลางาน', col_span: 11 },
        other_cost_price: { input_type: 'text', placeholder: 'ค่าใช้จ่ายอื่นๆ', col_span: 11 },
        other_price: { input_type: 'text', placeholder: 'อื่นๆ', col_span: 11 },
        uniform_price: { input_type: 'text', placeholder: 'ค่าเครื่องแบบ', col_span: 11 },
        bill_price: { input_type: 'text', placeholder: 'ค่าทำผิดกฎ', col_span: 11 },
        outway_price: { input_type: 'text', placeholder: 'ใช้รถนอกเส้นทาง', col_span: 11 },
        sum_price: { input_type: 'text', placeholder: 'เงินหักรวม', col_span: 11 ,non_editable:true},
    },
    inputs3: {
        divider_4: {
            input_type: 'divider',
            label: 'ข้อมูลสรุปยอดเงินเดือน',
            col_span: 23
        },
        total_price: { input_type: 'number', placeholder: 'เงินได้สุทธิ', col_span: 23 ,non_editable:true},
        consume_price: { input_type: 'number', placeholder: 'เงินได้สะสม', col_span: 11 },
        tax_price: { input_type: 'number', placeholder: 'ภาษีสะสม', col_span: 11 },
        social_insurance_price: { input_type: 'number', placeholder: 'ประกันสังคมสะสม', col_span: 11 },
        fund_price: { input_type: 'number', placeholder: 'กองทุนสำรองเลี้ยงชีพสะสม', col_span: 11 }
    }
};

export default salary_fields